import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { get } from "@/lib/api";

export default function Settings() {
  const { data } = useQuery({ queryKey: ["partner-dashboard"], queryFn: () => get("/partner/dashboard") });
  const studio = data?.studio;
  const inputCls = "w-full rounded-md border border-[#E2E8F0] bg-white px-3 py-2 text-sm outline-none focus:border-[#2D2926]";

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-semibold tracking-tight">Ayarlar</h1>
      <p className="text-sm text-[#64748B]">Stüdyo profil bilgileri</p>

      <form onSubmit={(e) => { e.preventDefault(); toast.success("Ayarlar kaydedildi (demo)"); }} className="mt-5 space-y-4 rounded-md border border-[#E2E8F0] bg-white p-6">
        <div>
          <label className="mb-1 block text-sm text-[#475569]">Stüdyo adı</label>
          <input data-testid="settings-name" className={inputCls} defaultValue={studio?.name} />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="mb-1 block text-sm text-[#475569]">Bölge</label>
            <input className={inputCls} defaultValue={studio?.region} />
          </div>
          <div>
            <label className="mb-1 block text-sm text-[#475569]">Kapasite</label>
            <input type="number" className={inputCls} defaultValue={studio?.capacity} />
          </div>
        </div>
        <div>
          <label className="mb-1 block text-sm text-[#475569]">Açıklama</label>
          <textarea rows={3} className={inputCls} defaultValue={studio?.description} />
        </div>
        <div>
          <label className="mb-1 block text-sm text-[#475569]">Varsayılan kredi fiyatı</label>
          <input type="number" className={inputCls} defaultValue={studio?.credit_price} />
        </div>
        <button data-testid="settings-save" type="submit" className="rounded-md bg-[#2D2926] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#1A1715]">Kaydet</button>
      </form>
    </div>
  );
}
